import React from 'react';
import styled, { css } from 'styled-components';

const TabStyled = styled.div.attrs({
  className: 'tab',
})`
  ${props => {
    const { theme = {}, active = false, darkMode } = props;
    const { colors = {}, fonts = {}, media = {} } = theme;
    return css`
      span {
        display: inline-block;
        list-style: none;
        margin-bottom: -1px;
        padding: 0.5rem 0.75rem;
        color: #999;
        cursor: pointer;
        background-color: #fff;
        border-right: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        border-top: 1px solid #ccc;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;

        ${darkMode && `
          background-color: #000;
        `}        

        &:first-child {
          border-left: 1px solid #ccc;
        }

        &:not(:last-child, :first-child) {
          border-left: 1px solid #ccc;
        }

        ${active && `
          background-color: #fff;
          color: #000;
          border-bottom: 1px solid transparent;
          border-right: 1px solid #ccc;
        `}

        ${active && darkMode && `
          background-color: #000;
          color: #fff;
          border-bottom: 1px solid transparent;
          border-right: 1px solid #ccc;
        `}
      }
    `;
  }}
`;

const Tab = ({ label, activeTab, onClick, darkMode }) => {
  const tabClick = () => {
    onClick(label);
  }

  return (
    <TabStyled
      active={activeTab === label}
      onClick={tabClick}
      darkMode={darkMode}
      data-label={label}
    >
      <span>{label}</span>
    </TabStyled>
  ); 
}

export default Tab;